import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getLanguage, getQueryString } from '../../../utils/params';
import { Faqs, HeadUseful, OurCustomer } from '../common/index';
// import { isMobile } from '../../../utils/constants';
import { FaqImageFooter } from '../../../assets/images/web-isn';
import { getRentalFlow, getUsefulFaq, getRentingBanner } from '../usefulPage.api';
import useFullPageLoader from 'modules/commons/isn/useFullPageLoader';

const FaqsComponent = () => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const location = useLocation();
  const language = getLanguage(location);
  const { t } = useTranslation();

  const slitLocation = location.pathname.split('/');
  let params = '';
  if (slitLocation.length) {
    params = slitLocation[slitLocation.length - 1];
  }
  const [showRental, setShowRental] = useState(true);
  const [rentalFlowLong, setRentalFlowLong] = useState(null);
  const [rentalFlowShort, setRentalFlowShort] = useState(null);
  const [rentalFlow, setRentalFlow] = useState(null);
  const [faq, setFaq] = useState(null);
  const [imageBannerUrl, setImageBannerUrl] = useState(null);

  // const [rentalType, setRentalType] = useState(type)

  // useEffect(() => {
  //   if (!location.pathname.includes('/useful-information/all')) {
  //     if (params === 'renting-process') {
  //       props.getUsefulInformationRequest({
  //         language,
  //         category: 3,
  //       });
  //     }
  //   }
  //   const scrollTo = document.querySelector('#useful-position-scroll');
  //   if (scrollTo) {
  //     scrollTo.scrollIntoView({ behavior: 'smooth' });
  //   }
  //   // eslint-disable-next-line
  // }, [params]);

  useEffect(() => {
    showLoader();
    if (window.location.href.includes('apartment-renting-process')) {
      // Get banner data
      getRentingBanner(getQueryString({ language })).then(res => {
        if (res) {
          setImageBannerUrl(res.imageUrl);
        }
      });

      // Get Long data
      getRentalFlow(getQueryString({ language, type: 1 })).then(res => {
        if (res) {
          setRentalFlowLong(res);
          setRentalFlow(res);
        }
      });

      // Get Short data
      getRentalFlow(getQueryString({ language, type: 2 })).then(res => {
        if (res) {
          setRentalFlowShort(res);
        }
      });
    } else if (window.location.href.includes('faqs')) {
      setRentalFlow(null);
      setRentalFlowLong(null);
      setRentalFlowShort(null);

      getUsefulFaq(getQueryString({ language })).then(res => {
        if (res) {
          setFaq(res);
        }
      });
    }
    hideLoader();
    // eslint-disable-next-line
  }, []);

  const renderRentalFlow = () => {
    return (
      <div className="col-12">
        <div className="row row-data">
          {rentalFlow && rentalFlow.length
            ? rentalFlow.map((item, index) => {
              if (item.content && item.title !== 'null') {
                return (
                  <React.Fragment key={index}>
                    <div className="col-2 col-vertical">
                      <div className="div">
                        <div className="dot"></div>
                      </div>
                    </div>
                    <div className="col-9 col-content">
                      <div className="wrap-content">
                        <div
                          className="content jp-font-sawarabi-gothic"
                          dangerouslySetInnerHTML={{ __html: item.content || '' }}
                        ></div>
                        <div className="label">
                          <div className="top jp-600-sawarabi">{`${t('usefulPage.label_step')} ${index + 1}`}</div>
                          <div className="middle">
                            <div></div>
                          </div>
                          <div className="bottom jp-400-sawarabi" title={item.title}>
                            {item.title}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-1 col-empty"></div>
                  </React.Fragment>
                );
              }
              return '';
            })
            : ''}
        </div>
      </div>
    );
  };

  const renderOther = () => {
    return (
      <div className="page-faq-tenants">
        <div className="row">
          <div className="col-1"></div>
          <div className="title-faq-tenants col-10">
            <div className="faqs-title">{t('usefulPage.label_faqs_title')}</div>
            <div className="d-flex justify-content-center">
              <div className="faqs-red-line"></div>
            </div>
            {/* <div
              className="text-description jp-400-sawarabi"
              dangerouslySetInnerHTML={{
                __html:
                  params === 'faq' ? t('useful_page.faq.description') : t('useful_page.useful_for_tenants.description'),
              }}
            ></div> */}
          </div>
          <div className="col-1"></div>
        </div>
        <div className="row">
          <div className="col-1 col-md-1"></div>
          <div className="col-10 col-md-10 p-0">{faq && faq.length > 0 ? <Faqs faq={faq} /> : ''}</div>
          <div className="col-1 col-md-1"></div>
        </div>
      </div>
    );
  };

  const onClickLongRentalTab = () => {
    setRentalFlow(rentalFlowLong);
    setShowRental(true);
  };

  const onClickShortRentalTab = () => {
    setRentalFlow(rentalFlowShort);
    setShowRental(false);
  };

  return (
    <div>
      <section
        className={`useful-information ${location.pathname.includes('/useful-information/all') ? 'all-category' : ''} ${params === 'faq' || params === 'useful-information-for-tenants' ? 'faq-tenants' : ''
          } ${params === 'our-customer-support-service' ? 'our-customer' : ''}`}
      >
        <HeadUseful />
        {!location.pathname.includes('/useful-information/all') ? (
          <>
            {params === 'apartment-renting-process' ? (
              <div className="container">
                <div className="col-12 banner-rental">
                  <img alt="" className="img-banner" src={`${process.env.REACT_APP_ISN_IMAGE_URL}${imageBannerUrl}`} />
                </div>

                <ul className="nav nav-tabs" role="tablist">
                  <li className="nav-item" role="presentation">
                    <span
                      onClick={() => {
                        onClickLongRentalTab();
                      }}
                      className={showRental === true ? 'nav-link active' : 'nav-link disable'}
                      id="Residence-tab"
                      data-toggle="tab"
                      role="tab"
                    >
                      {t('home_page.search.tab_long_term')}
                    </span>
                  </li>
                  <li className="nav-item" role="presentation">
                    <span
                      onClick={() => {
                        onClickShortRentalTab();
                      }}
                      className={showRental === false ? 'nav-link active' : 'nav-link disable'}
                      id="Office-tab"
                      data-toggle="tab"
                      role="tab"
                    >
                      {t('home_page.search.tab_short_term')}
                    </span>
                  </li>
                </ul>
                {renderRentalFlow()}
              </div>
            ) : (
              ''
            )}
            {params === 'our-customer-support-service' ? <OurCustomer /> : ''}
            {params === 'faqs' ? <div className="container p-0"> {renderOther()} </div> : ''}
          </>
        ) : (
          ''
        )}
      </section>
      {params === 'faqs' ? (
        <div style={{ paddingTop: '6px' }}>
          <img className="faq-image-footer" src={FaqImageFooter} alt="" />
        </div>
      ) : (
        ''
      )}
      {loader}
    </div>
  );
};

export default FaqsComponent;
